<div class="_content flex flex-column"
     [ngClass]="hideUpOpenUp ? 'flex-justify-start' : 'flex-justify-end'">
    <div #content>
        <ng-content></ng-content>
    </div>
</div>